const TENANT_KEY = "wirelesspress_selected_company_id";
const TENANT_NAME_KEY = "wirelesspress_selected_company_name";

export function getRole() {
  return localStorage.getItem("role") || "";
}

export function isSuperAdmin() {
  return getRole() === "super_admin";
}

export function getSessionCompanyId() {
  return localStorage.getItem("company_id") || "";
}

export function getSelectedCompanyId() {
  if (!isSuperAdmin()) {
    return getSessionCompanyId();
  }

  return (
    localStorage.getItem(TENANT_KEY) ||
    getSessionCompanyId() ||
    ""
  );
}

export function getExplicitSelectedCompanyId() {
  if (!isSuperAdmin()) {
    return getSessionCompanyId();
  }

  return localStorage.getItem(TENANT_KEY) || "";
}


export function tenantPath(path, requireExplicitSuperAdmin = true) {
  const companyId = getExplicitSelectedCompanyId();

  if (!companyId) {
    if (requireExplicitSuperAdmin && isSuperAdmin()) {
      throw new Error(
        "Select a company before accessing tenant-scoped data."
      );
    }

    return path;
  }

  const separator = path.includes("?") ? "&" : "?";

  return `${path}${separator}company_id=${encodeURIComponent(
    companyId
  )}`;
}

export function getSelectedCompanyName() {
  return localStorage.getItem(TENANT_NAME_KEY) || "";
}

export function setSelectedCompany(companyId, companyName = "") {
  const id = String(companyId || "").trim();

  if (!id) {
    localStorage.removeItem(TENANT_KEY);
    localStorage.removeItem(TENANT_NAME_KEY);
  } else {
    localStorage.setItem(TENANT_KEY, id);

    if (companyName) {
      localStorage.setItem(
        TENANT_NAME_KEY,
        String(companyName)
      );
    }
  }

  window.dispatchEvent(
    new CustomEvent("wirelesspress-tenant-change", {
      detail: {
        companyId: id,
        companyName,
      },
    })
  );
}

export function clearSelectedCompany() {
  setSelectedCompany("", "");
}
